import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';

const OrderPrefix = ({ isLoading }) => (
	<FormItem label="orderPrefix" isLoading={isLoading} toolTip="orderPrefixToolTipContent">
		<StringInput name="prefix" placeholder="orderPrefixPlaceholder" />
	</FormItem>
);

export default OrderPrefix;
